import { BaseTextFieldProps } from '@mui/material/TextField';
import React, { HTMLAttributes } from 'react';

type InputComponentProps = Pick<BaseTextFieldProps, 'inputRef'> & HTMLAttributes<HTMLDivElement>;

export const InputComponent = ({ inputRef, ...props }: InputComponentProps) => {
  return <div ref={inputRef} {...props} />;
};
